<div class="game-tournament-container" *ngIf="isLogin && reactivationData">
    <div id="campaigns-front" class="tournamentContainer" fxLayout="row" fxLayoutAlign="center center">
        <h2 fxLayoutAlign="center center" class="tournament-title"><img class="tournament-icon" src="{{licenceService.getKey('compaign-switch')}}"><span i18n>Switch ON Bison</span> </h2>
        <span class="spacer"></span>
        <a class="button-all-games" mat-button color="primary" [routerLink]="['/', reactivationTrx]" i18n>All Days</a>
        <div class="swiper-navigation">
            <img src="{{licenceService.getKey('icon-right')}}" alt="yellow-arrow" icon-btn direction="left" (click)="prev()">
            <img src="{{licenceService.getKey('icon-right')}}" alt="yellow-arrow" icon-btn class="button-next" (click)="next()">
        </div>

    </div>
    <div class="card-wrapper">
        <swiper fxFlex="auto" [config]="config" #swiper>
            <ng-template swiperSlide *ngFor="let item of reactivationData | keyvalue | slice:0:7; let index = index">
                <!-- <app-home-page-mission-card [routeURL]="missionsTrx" [mission]="item" [isEmbedded]="false" [tournamentIndex]="index"></app-home-page-mission-card> -->
                <app-reactivation-info [item]="item" [index]="index" [currentRecursivePointer]="reactivationData?.currentRecursivePointer"></app-reactivation-info>
            </ng-template>
        </swiper>
    </div>
</div>